import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Regulation } from '../../Regulation'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'

const ModalTermsDonation = props => (
  <Modal
    width='1180'
    height='345'
    effect='fadeInUp'
    onClickAway={() => props.onClose()}
    visible={props.show}
  >
    <Fragment>
      <div
        className={`col-12 border-bottom-lg border-color-featured bg-white py-4 mr-auto ml-auto`}
      >
        <div className='row px-3'>
          <div className='col'>
            <h2>Termos do regulamento de doações</h2>
          </div>
          <div className='col-auto'>
            <Button
              id='close'
              name={'Close'}
              className='btn btn-double btn-flat btn-icon-only btn-icon'
              iconName='icon_close icon-sm'
              text=''
              aria-label='Fechar'
              onClick={e => props.onClose()}
            />
          </div>
        </div>
        <div className='col-12'>
          <div className='row px-3'>
            <div className='col mx-0 mt-4 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'>
              <div className='row mx-1'>
                <div className='col-12 pr-3 color-ui-2 txt-font-body txt-body-sm'>
                  <Regulation vendorId={props.terms.vendorId} />
                  Diante da referida premiação, declaro para todos os fins que
                  aceito doar reales para o Programa Movimento Solidário, para
                  desenvolver os objetivos de desenvolvimento sustentável, na
                  qual disponho do valor em prol ao programa.
                  <br />
                  “Segundo a legislação fiscal vigente esta doação não é
                  dedutível do Imposto de Renda”.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 pt-3'>
          <div className='row  align-items-center h-100  px-3'>
            <div className='modal-back col-2 px-0 txt-left mr-auto'>
              <Button
                id={'AddMoreProducts'}
                name={'AddMoreProducts'}
                className='btn btn-sm btn-flat'
                iconName='icon_left icon-sm'
                text='Voltar'
                onClick={e => props.onClose()}
              />
            </div>
            <div className='modal-back col-4 px-0 txt-right'>
              <Button
                id={'Agree-donation'}
                name={'Agree'}
                className='btn btn-double btn-featured btn-icon mx-0'
                iconName='icon_check_circle'
                text='LI E ACEITO O REGULAMENTO'
                onClick={e => props.acceptTerms()}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  </Modal>
)

ModalTermsDonation.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  acceptTerms: PropTypes.func,
  terms: PropTypes.object
}

export default ModalTermsDonation



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ModalTermsDonation/ModalTermsDonation.js